
import React, { Component } from 'react';
import { connect } from "react-redux";
import Track from 'track/Track.js';

class StepsRowBottom extends Component {
    render() {
        let currentStep  = this.props.currentStep;
        let width = this.props.isMini ? 20 : 32;
        let marginLeft = width * currentStep;
        let beatDivisions = Math.floor(currentStep / 4);
        let offset = this.props.isMini ? 15 : 30;
        let style = {
            width: marginLeft + offset
        };
        return (
            <div className="steps-row-bottom">
              {currentStep !== undefined ? 
              <div
                style={style}
                className="current-step-box">
                <div className="right-box"/>
              </div> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let id = ownProps.sequencerEngine.getSequenceId();

    let stepsLength = !state.tracks.trackSteps[ownProps.track.id] ?
        16 : state.tracks.trackSteps[ownProps.track.id].length;
    var currentGlobal = state.sequencer.currentGlobalStep[id] || 0;
    var patternStep = ownProps.track.getPatternStep(currentGlobal, false);
    var current = Math.floor(
        patternStep /
            (Track.baseResolution.numSteps() /
             state.sequencer.displayResolution.numSteps()));
    current = current % stepsLength;
    let minStep = ownProps.chunk * ownProps.stepsInRow;
    let maxStep = (ownProps.chunk + 1) * ownProps.stepsInRow;

    return {
        currentStep: current >= minStep && current < maxStep ?
            current % ownProps.stepsInRow : undefined,
    }
};

export default connect(mapStateToProps, null )(StepsRowBottom);

